import React from "react";
import "./input.css";

/**
 * Input Component — standard single-line text input.
 *
 * Uses the theme-level body text size so input text is uniform across the app.
 *
 * @param {Object} props
 * @param {string} props.className - Additional CSS classes (e.g. height overrides)
 * @param {string} props.background - Field background ('default' = gray, 'white')
 * @param {boolean} props.error - Whether to show the validation error state
 * @param {Object} props.rest - Additional props passed to the native input
 */
const Input = React.forwardRef(({
    className = "",
    background = "default",
    error = false,
    ...rest
}, ref) => {
    const backgroundClass = background === "white" ? "ui-input--white" : "";
    const errorClass = error ? "ui-input--error" : "";

    return (
        <input
            ref={ref}
            className={`ui-input ${backgroundClass} ${errorClass} ${className}`.replace(/\s+/g, " ").trim()}
            {...rest}
        />
    );
});

Input.displayName = "Input";

export default Input;
